<template>
  <div :class="['plate',mode]">
    <div class="title1">题材亮点</div>

    <div class="company_item" v-for="item in light">
      <div class="company_item_l color63">{{item.name}}</div>
      <div class="company_item_r">
        {{ item.list }}
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.41483 3.09038C4.69919 3.28943 4.69919 3.71057 4.41483 3.90962L0.786732 6.44929C0.455343 6.68126 0 6.44418 0 6.03967L0 0.960328C0 0.555816 0.455342 0.31874 0.786731 0.550712L4.41483 3.09038Z" fill="#FE484A"/>
          </svg>
        </span>
        
      </div>
    </div>


  </div>
</template>

<script>
export default {
  props:{
    light:{
      type:Array,
      default:[],
    }
  },
  data(){
        return{
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070
        }
    },
    created() {
        console.log(this.$route.params);
    },
}

</script>
<style lang="scss" scoped>
  @import "~@/assets/sass/globalapp.scss";
  .plate{
    padding: rem2(10px) rem2(12px);
    border-bottom: rem2(1px) solid #EBEBEB;//#121212
    .company_item{
      display: flex;
      font-size: rem2(13px);
      width: 100%;
      margin: rem2(10px) 0 0;
      line-height: rem2(20px);
      .company_item_l{
        width: 23%;
       
      }
      .company_item_r{
        width: 77%;
        span{
          height: rem2(20px);
          display: inline-flex;
          align-items: center;
          
          >svg{
            width: rem2(14px);
            position: relative;
            bottom: rem2(-1.5px);
            height: rem2(10px);
          }
        }

      }
    }
  }

  .light_mode{

  }

  .dark_mode{
    .plate{
      border-bottom-color: #121212;//
    }
    
  }
</style>